import {useLocation, useNavigate} from "react-router-dom";
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import { FormEvent, useState } from "react";
import AdminNav from "../../Components/AdminNav/AdminNav";
import { IMAGE_URL } from "../../path";
import { editHomeImage } from "../../actions/HomePageImages";

function EditHome() {
  const location = useLocation();
  const user = location.state?.user;
  const image = location.state?.image;

    const navigate = useNavigate();

    if (location === null || location.state === null || location.state.user === null) {
        navigate('/login');
    }

  const [isCollapsed, setIsCollapsed] = useState(true);
  const [title, setTitle] = useState(image.title);
  const [link, setLink] = useState(image.link);
  const [displayOrder, setDisplayOrder] = useState(image.display_order);

  const [imageFileDesktop, setImageFileDesktop] = useState<File | null>(null);
  const [previewUrlDesktop, setPreviewUrlDesktop] = useState<string>(`${IMAGE_URL}${image.image_path}`);

  const [imageFileMobile, setImageFileMobile] = useState<File | null>(null);
  const [previewUrlMobile, setPreviewUrlMobile] = useState<string>(`${IMAGE_URL}${image.mobile_image_path}`);

  const [imageError, setImageError] = useState<string>("");

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>, type: "desktop" | "mobile") => {
    const file = e.target.files?.[0];
    if (file) {
      if (!["image/jpeg", "image/jpg", "image/png"].includes(file.type)) {
        setImageError("Please upload a valid image file (jpg, jpeg, or png).");
        if (type === "desktop") setImageFileDesktop(null);
        else setImageFileMobile(null);
        return;
      }

      setImageError("");
      const objectUrl = URL.createObjectURL(file);

      if (type === "desktop") {
        setImageFileDesktop(file);
        setPreviewUrlDesktop(objectUrl);
      } else {
        setImageFileMobile(file);
        setPreviewUrlMobile(objectUrl);
      }
    }
  };

  const removeSelectedImage = (type: "desktop" | "mobile") => {
    if (type === "desktop") {
      setImageFileDesktop(null);
      setPreviewUrlDesktop(`${IMAGE_URL}${image.image_path}`);
    } else {
      setImageFileMobile(null);
      setPreviewUrlMobile(`${IMAGE_URL}${image.mobile_image_path}`);
    }
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (!title || !link || !displayOrder) {
      alert("Please fill in all required fields.");
      return;
    }

    try {
      await editHomeImage({
        id: image.id,
        title,
        link,
        display_order: Number(displayOrder),
        image: imageFileDesktop ?? undefined,
        mobile_image: imageFileMobile ?? undefined,
      });

      alert("Home page image updated successfully!");
    } catch (error: any) {
      console.error("Update failed:", error);
      alert("Failed to update home page image. Please try again.");
    }
  };

  return (
    <div>
      <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user} />
      <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user} />



      <div className={`main-admin-page ${isCollapsed ? 'collapsed' : 'expanded'}`}>
        <div className="main-admin-page-inner">
          <form onSubmit={handleSubmit}>
            <div className="content-form-field">
              <h2>Edit Home Page Image</h2>
              <input
                type="text"
                className="input-email"
                placeholder="Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
            </div>

            <div className="content-form-field">
              <input
                type="text"
                className="input-email"
                placeholder="Link"
                value={link}
                onChange={(e) => setLink(e.target.value)}
                required
              />
            </div>
            <div className="content-form-field">
              <input
                type="text"
                className="input-email"
                placeholder="Display Order"
                value={displayOrder}
                onChange={(e) => setDisplayOrder(e.target.value)}
                required
              />
            </div>

            {/* Desktop Image Upload */}
            <div className="content-form-field">
              <label><strong>Desktop Image</strong></label><br />
              <input
                type="file"
                accept=".jpg,.jpeg,.png"
                onChange={(e) => handleImageChange(e, "desktop")}
                style={{ margin: '10px 0' }}
              />
              {imageError && <div style={{ color: 'red' }}>{imageError}</div>}
              {previewUrlDesktop && (
                <div style={{ marginTop: '10px' }}>
                  <img
                    src={previewUrlDesktop}
                    alt="Desktop Preview"
                    style={{ maxWidth: '100%', maxHeight: '300px', border: '1px solid #ccc' }}
                  />
                  <br />
                  <button type="button" onClick={() => removeSelectedImage("desktop")} style={{ marginTop: '5px' }}>
                    Remove Desktop Image
                  </button>
                </div>
              )}
            </div>

            {/* Mobile Image Upload */}
            <div className="content-form-field">
              <label><strong>Mobile Image</strong></label><br />
              <input
                type="file"
                accept=".jpg,.jpeg,.png"
                onChange={(e) => handleImageChange(e, "mobile")}
                style={{ margin: '10px 0' }}
              />
              {imageError && <div style={{ color: 'red' }}>{imageError}</div>}
              {previewUrlMobile && (
                <div style={{ marginTop: '10px' }}>
                  <img
                    src={previewUrlMobile}
                    alt="Mobile Preview"
                    style={{ maxWidth: '100%', maxHeight: '300px', border: '1px solid #ccc' }}
                  />
                  <br />
                  <button type="button" onClick={() => removeSelectedImage("mobile")} style={{ marginTop: '5px' }}>
                    Remove Mobile Image
                  </button>
                </div>
              )}
            </div>

            <button type="submit" className="btn-submit">Save Changes</button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default EditHome;
